import React, { useState } from 'react';
import './Chatbox.css';

const ChatBox = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');

    // Toggle chatbox open/close
    const toggleChat = () => {
        setIsOpen(!isOpen);
    };

    // Handle sending a message
    const handleSend = () => {
        if (input.trim() !== '') {
            // Add user message to messages
            const userMessage = { text: input, sender: 'user' };
            setMessages((prevMessages) => [...prevMessages, userMessage]);

            // Auto reply based on user message
            if (input.toLowerCase() === 'hi' || input.toLowerCase() === 'hello') {
                const botReply = {
                    text: 'Hello! How can I assist you today?',
                    sender: 'bot',
                };
                setTimeout(() => {
                    setMessages((prevMessages) => [...prevMessages, botReply]);
                }, 500); // Simulate bot delay
            }

            // Open email client with pre-filled email
            const recipient = 'info@vajraiot.com';
            const subject = 'New Chat Message';
            const body = input;
            const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(recipient)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            window.open(gmailUrl, '_blank');

            setInput(''); // Clear the input field

            // Inform user to send the email
            alert("Gmail will open in a new tab. Please click 'Send' to submit your message!");
        }
    };

    return (
        <div className="chatbox-container">
            {/* Chat Bubble when the chat is closed */}
            {!isOpen && (
                <div className="chatbox-bubble" onClick={toggleChat}>
                    <div className="bubble-text">
                        <strong>We're Online!</strong>
                        <br />
                        How may I help you today?
                    </div>
                    {/* Fix emoji accessibility */}
                    <div className="bubble-icon">
                        <span role="img" aria-label="Speech Bubble">
                            💬
                        </span>
                    </div>
                </div>
            )}

            {/* Chatbox when it's open */}
            {isOpen && (
                <div className="chatbox">
                    <div className="chatbox-header">   
                        Chat with Us
                        <button className="chatbox-close-btn" onClick={toggleChat}>
                            {/* Fix potential emoji accessibility if used */}
                            ✖
                        </button>
                    </div>
                    <div className="chatbox-messages">
                        {messages.map((msg, index) => (
                            <div
                                key={index}
                                className={`chatbox-message ${msg.sender}`}
                            >
                                {msg.text}
                            </div>
                        ))}
                    </div>
                    <div className="chatbox-input">
                        <input
                            type="text"
                            placeholder="Type a message..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') handleSend();
                            }}
                        />
                        <button onClick={handleSend}>Send</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatBox;